import { createContext, useContext, useEffect, useState } from "react";
import { basePath } from "../components/config";
import { useParams } from "react-router-dom";
import { useAuth } from "./auth";
import { toast } from "react-toastify";

export const OrderDetailStateContext = createContext(null);
export const OrderDetailUpdateContext = createContext(null);

export function OrderDetailsProvider({ children }) {
  const { orderId } = useParams();
  const [orderDetails, setOrderDetails] = useState();
  const [isPaperSizeFormOpen, setPaperSizeFormOpen] = useState(false);
  const [papersData, setPapersData] = useState();
  const [paperSizes, setPaperSizes] = useState();
  const [labelSizes, setLabelSizes] = useState();
  const [{ activeUser }] = useAuth();

  useEffect(() => {
    let flag = true;
    (async () => {
      try {
        const res = await fetch(basePath + "getOrderData", {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${activeUser?.remember_token}`,
          },
          body: JSON.stringify({ orderId }),
        });

        const data = await res.json();

        if (res.status === 401) {
          toast.error(data.message);
          document.cookie =
            "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          return 0;
        }
        if (flag) {
          if (data.status) {
            setOrderDetails(JSON.parse(data.data));
            setPapersData(JSON.parse(data.papers));
            setPaperSizes(JSON.parse(data.paper_size));
            setLabelSizes(data.labels)
          }
        }
      } catch (error) {
        console.error("getOrderData:: api calling fail =>", error);
      }
    })();

    return () => {
      flag = false;
    };
  }, [orderId]);

  const state = {
    orderDetails,
    papersData,
    paperSizes,
    isPaperSizeFormOpen,
    labelSizes,
  };
  const updateFns = {
    setOrderDetails,
    setPapersData,
    setPaperSizes,
    setPaperSizeFormOpen,
    setLabelSizes,
  };

  return (
    <OrderDetailStateContext.Provider value={state}>
      <OrderDetailUpdateContext.Provider value={updateFns}>
        {children}
      </OrderDetailUpdateContext.Provider>
    </OrderDetailStateContext.Provider>
  );
}

export function useOrderDetails() {
  const state = useContext(OrderDetailStateContext);
  const updateFns = useContext(OrderDetailUpdateContext);
  return [state, updateFns];
}
